export enum BRANDING_DEFAULT_COLORS {
  PRIMARY = '#FF224C',
  HIGHLIGHT = '#51B551',
  SUCCESS = '#51B551',
  WARNING = '#EF8600',
  INFO = '#2DB5DB',
  DANGER = '#D1423F',
}
